export interface DownloadedFile {
    fileName: string;
    blob: Blob;
}

/**
 * Hands a downloaded file to the browser. Mirrors how the offers table exports its CSV.
 */
export const saveDownloadedFile = (file: DownloadedFile): void => {
    const url = URL.createObjectURL(file.blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", file.fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

/**
 * The server names the file. The header is exposed to the browser by the platform's CORS
 * configuration; the fallback covers the case where a proxy strips it.
 */
export const readFileName = (contentDisposition: string | null, fallback: string): string => {
    if (!contentDisposition) {
        return fallback;
    }

    const quoted = contentDisposition.match(/filename="([^"]+)"/);
    if (quoted) {
        return quoted[1];
    }

    const unquoted = contentDisposition.match(/filename=([^;]+)/);
    return unquoted ? unquoted[1].trim() : fallback;
};

/**
 * The platform returns plain text error bodies, which are written for the operator to read.
 */
export const readErrorMessage = async (response: Response, fallback: string): Promise<string> => {
    try {
        const body = await response.text();
        return body && body.trim() ? body : fallback;
    } catch {
        return fallback;
    }
};
